import React, { useState } from 'react'
import { Button, Modal } from 'antd'
import { ComplianceReport } from './types'
import './style.less'
import { LockOutlined, CloseCircleTwoTone } from '@ant-design/icons'
import { LockReport } from './lockReport'
import { IPeriodCache } from '../../lib/interfaces'
import LockProgress from './LockProgress'
import { APIFunctions } from '../../lib/apiFunctions'
import { useSessionIfExists } from '../../hooks/useAuth'

export default function LockModal({
    reportMeta,
    llPeriod,
    visible,
    setVisible,
    loadOverviewData,
    apiFunctions,
    switchToTab,
}: {
    apiFunctions: APIFunctions
    reportMeta: ComplianceReport | undefined
    visible: boolean
    setVisible: (isV: boolean) => void
    llPeriod: IPeriodCache | null
    loadOverviewData: (tab?: string) => void
    switchToTab: (tab: string) => void
}) {
    const [lockModal, setLockModalVisible] = useState<boolean>(false)
    const [lockedReportID, setLockedReportID] = useState<string | null>(null)
    const [DDKey, setDDKey] = useState<number>(new Date().valueOf())
    const { session } = useSessionIfExists()

    const handleCancel = () => {
        setVisible(false)
    }

    if (lockedReportID && reportMeta?.ll_tax_year_id) {
        switchToTab(`taxYearReport;;;${reportMeta.ll_tax_year_id}:::${lockedReportID}`)
    }

    async function exportFun(callback) {
        try {
            if (!session) throw new Error('no session was found')
            if (!reportMeta) throw new Error('no reportMeta was found')
            if (!llPeriod) throw new Error('no llPeriod was found')
            const localLockedReportID = await LockReport(
                session,
                reportMeta.id,
                llPeriod.id,
                callback,
                apiFunctions
            )
            await loadOverviewData(
                `taxYearReport;;;${reportMeta.ll_tax_year_id}:::${localLockedReportID}`
            )
            setLockedReportID(localLockedReportID)
        } catch (error) {
            onExportFail(error)
        }
    }

    const onExportFail = (error) => {
        Modal.confirm({
            icon: <CloseCircleTwoTone twoToneColor={'red'} />,
            title: 'Could not lock report',
            content: error,
            cancelText: 'Cancel',
        })
        setLockModalVisible(false)
        setDDKey(new Date().valueOf())
    }

    return (
        <>
            <Modal
                destroyOnClose
                visible={visible}
                title={'Lock Report and Share'}
                footer={[]}
                onCancel={handleCancel}
            >
                <p>
                    Locking a report will make a copy of your current report and prevent future
                    changes. The changes you make in the app afterwards will only affect reports
                    without locks.
                    <br />
                    You can always unlock your report later.
                </p>
                <Button
                    onClick={() => {
                        setLockModalVisible(true)
                    }}
                    icon={<LockOutlined />}
                >
                    Lock
                </Button>
                <div key={DDKey}>
                    <LockProgress
                        exportFunction={exportFun}
                        requestLock={lockModal}
                        setIsLoading={setLockModalVisible}
                        onFail={onExportFail}
                    />
                </div>
            </Modal>
        </>
    )
}
